/* eslint-disable @eon/no-hardcoded-colors -- false positives from text strings like "Invoice #4821" */
import type { GWConnectorNode } from '@/app/(dashboard)/saas-inventory/google-workspace/googleWorkspaceTypes';

export const googleWorkspaceMockData: GWConnectorNode[] = [
  {
    id: 'conn-gw-001',
    name: 'FinApp Production Workspace',
    type: 'connector',
    provider: 'google-workspace',
    status: 'active',
    lastBackup: '2026-04-04T22:30:00Z',
    children: [
      {
        id: 'shared-drives',
        name: 'Shared Drives',
        type: 'folder',
        size: 21474836480,
        modified: '2026-04-04T18:10:00Z',
        children: [
          {
            id: 'sd-001',
            name: 'Marketing',
            type: 'shared-drive',
            size: 5368709120,
            modified: '2026-04-03T14:22:00Z',
            children: [
              {
                id: 'sd-001-f01',
                name: 'Campaigns',
                type: 'folder',
                size: 7363584,
                modified: '2026-04-02T10:00:00Z',
                children: [
                  {
                    id: 'sd-001-f01-f01',
                    name: 'Q1 2026',
                    type: 'folder',
                    size: 4033536,
                    modified: '2026-03-20T09:15:00Z',
                    children: [
                      {
                        id: 'sd-001-f01-f01-001',
                        name: 'Launch Plan.docx',
                        type: 'file',
                        size: 245760,
                        modified: '2026-03-15T10:30:00Z',
                      },
                      {
                        id: 'sd-001-f01-f01-002',
                        name: 'Budget.xlsx',
                        type: 'file',
                        size: 102400,
                        modified: '2026-03-20T09:15:00Z',
                      },
                      {
                        id: 'sd-001-f01-f01-f01',
                        name: 'Creative Assets',
                        type: 'folder',
                        size: 3685376,
                        modified: '2026-03-12T09:05:00Z',
                        children: [
                          {
                            id: 'sd-001-f01-f01-f01-001',
                            name: 'Banner_1200x628.png',
                            type: 'file',
                            size: 2097152,
                            modified: '2026-03-10T16:00:00Z',
                          },
                          {
                            id: 'sd-001-f01-f01-f01-002',
                            name: 'Logo_dark.svg',
                            type: 'file',
                            size: 15360,
                            modified: '2026-02-28T11:00:00Z',
                          },
                          {
                            id: 'sd-001-f01-f01-f01-f01',
                            name: 'Social Media',
                            type: 'folder',
                            size: 1572864,
                            modified: '2026-03-12T09:05:00Z',
                            children: [
                              {
                                id: 'sd-001-f01-f01-f01-f01-001',
                                name: 'LinkedIn_post_march.png',
                                type: 'file',
                                size: 1048576,
                                modified: '2026-03-12T09:00:00Z',
                              },
                              {
                                id: 'sd-001-f01-f01-f01-f01-002',
                                name: 'Twitter_header.png',
                                type: 'file',
                                size: 524288,
                                modified: '2026-03-12T09:05:00Z',
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: 'sd-001-f01-f02',
                    name: 'Q2 2026',
                    type: 'folder',
                    size: 3330048,
                    modified: '2026-04-02T10:00:00Z',
                    children: [
                      {
                        id: 'sd-001-f01-f02-001',
                        name: 'Strategy Draft.docx',
                        type: 'file',
                        size: 184320,
                        modified: '2026-04-01T13:45:00Z',
                      },
                      {
                        id: 'sd-001-f01-f02-f01',
                        name: 'Presentations',
                        type: 'folder',
                        size: 3145728,
                        modified: '2026-04-02T10:00:00Z',
                        children: [
                          {
                            id: 'sd-001-f01-f02-f01-001',
                            name: 'Kickoff Deck.pptx',
                            type: 'file',
                            size: 3145728,
                            modified: '2026-04-02T10:00:00Z',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 'sd-001-f02',
                name: 'Brand Guidelines',
                type: 'folder',
                size: 12271616,
                modified: '2026-02-01T10:05:00Z',
                children: [
                  {
                    id: 'sd-001-f02-001',
                    name: 'Brand Book 2026.pdf',
                    type: 'file',
                    size: 8388608,
                    modified: '2026-01-15T09:00:00Z',
                  },
                  {
                    id: 'sd-001-f02-002',
                    name: 'Color Palette.pdf',
                    type: 'file',
                    size: 524288,
                    modified: '2026-01-15T09:05:00Z',
                  },
                  {
                    id: 'sd-001-f02-f01',
                    name: 'Templates',
                    type: 'folder',
                    size: 3358720,
                    modified: '2026-02-01T10:05:00Z',
                    children: [
                      {
                        id: 'sd-001-f02-f01-001',
                        name: 'Presentation Template.pptx',
                        type: 'file',
                        size: 3145728,
                        modified: '2026-02-01T10:00:00Z',
                      },
                      {
                        id: 'sd-001-f02-f01-002',
                        name: 'Document Template.docx',
                        type: 'file',
                        size: 204800,
                        modified: '2026-02-01T10:05:00Z',
                      },
                      {
                        id: 'sd-001-f02-f01-f01',
                        name: 'Email Signatures',
                        type: 'folder',
                        size: 8192,
                        modified: '2026-01-20T08:05:00Z',
                        children: [
                          {
                            id: 'sd-001-f02-f01-f01-001',
                            name: 'Signature_standard.html',
                            type: 'file',
                            size: 4096,
                            modified: '2026-01-20T08:00:00Z',
                          },
                          {
                            id: 'sd-001-f02-f01-f01-002',
                            name: 'Signature_exec.html',
                            type: 'file',
                            size: 4096,
                            modified: '2026-01-20T08:05:00Z',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 'sd-001-f03',
                name: 'Events',
                type: 'folder',
                size: 17866752,
                modified: '2026-03-06T10:00:00Z',
                children: [
                  {
                    id: 'sd-001-f03-f01',
                    name: 'SaaStr 2026',
                    type: 'folder',
                    size: 17866752,
                    modified: '2026-03-06T10:00:00Z',
                    children: [
                      {
                        id: 'sd-001-f03-f01-f01',
                        name: 'Booth Materials',
                        type: 'folder',
                        size: 17825792,
                        modified: '2026-03-06T10:00:00Z',
                        children: [
                          {
                            id: 'sd-001-f03-f01-f01-001',
                            name: 'Backdrop_design.ai',
                            type: 'file',
                            size: 15728640,
                            modified: '2026-03-05T14:00:00Z',
                          },
                          {
                            id: 'sd-001-f03-f01-f01-002',
                            name: 'Flyer_final.pdf',
                            type: 'file',
                            size: 2097152,
                            modified: '2026-03-06T10:00:00Z',
                          },
                        ],
                      },
                      {
                        id: 'sd-001-f03-f01-001',
                        name: 'Event Brief.gdoc',
                        type: 'file',
                        size: 40960,
                        modified: '2026-02-20T11:00:00Z',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: 'sd-002',
            name: 'Engineering',
            type: 'shared-drive',
            size: 12884901888,
            modified: '2026-04-04T18:10:00Z',
            children: [
              {
                id: 'sd-002-f01',
                name: 'Architecture',
                type: 'folder',
                size: 1298432,
                modified: '2026-04-02T11:35:00Z',
                children: [
                  {
                    id: 'sd-002-f01-001',
                    name: 'System Design.pdf',
                    type: 'file',
                    size: 1048576,
                    modified: '2026-03-28T14:00:00Z',
                  },
                  {
                    id: 'sd-002-f01-f01',
                    name: 'API Specs',
                    type: 'folder',
                    size: 188416,
                    modified: '2026-04-02T11:35:00Z',
                    children: [
                      {
                        id: 'sd-002-f01-f01-001',
                        name: 'openapi-v3.yaml',
                        type: 'file',
                        size: 81920,
                        modified: '2026-04-02T11:30:00Z',
                      },
                      {
                        id: 'sd-002-f01-f01-002',
                        name: 'graphql-schema.graphql',
                        type: 'file',
                        size: 40960,
                        modified: '2026-04-02T11:35:00Z',
                      },
                      {
                        id: 'sd-002-f01-f01-f01',
                        name: 'Deprecated',
                        type: 'folder',
                        size: 65536,
                        modified: '2025-09-15T10:00:00Z',
                        children: [
                          {
                            id: 'sd-002-f01-f01-f01-001',
                            name: 'openapi-v2.yaml',
                            type: 'file',
                            size: 65536,
                            modified: '2025-09-15T10:00:00Z',
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: 'sd-002-f01-f02',
                    name: 'Decision Records',
                    type: 'folder',
                    size: 61440,
                    modified: '2026-03-12T09:00:00Z',
                    children: [
                      {
                        id: 'sd-002-f01-f02-001',
                        name: 'ADR-001 Database Selection.md',
                        type: 'file',
                        size: 20480,
                        modified: '2026-01-20T10:00:00Z',
                      },
                      {
                        id: 'sd-002-f01-f02-002',
                        name: 'ADR-002 Auth Provider.md',
                        type: 'file',
                        size: 16384,
                        modified: '2026-02-05T14:00:00Z',
                      },
                      {
                        id: 'sd-002-f01-f02-003',
                        name: 'ADR-003 Event Streaming.md',
                        type: 'file',
                        size: 24576,
                        modified: '2026-03-12T09:00:00Z',
                      },
                    ],
                  },
                ],
              },
              {
                id: 'sd-002-f02',
                name: 'Runbooks',
                type: 'folder',
                size: 147456,
                modified: '2026-03-24T14:00:00Z',
                children: [
                  {
                    id: 'sd-002-f02-001',
                    name: 'Incident Response.md',
                    type: 'file',
                    size: 32768,
                    modified: '2026-03-01T09:00:00Z',
                  },
                  {
                    id: 'sd-002-f02-002',
                    name: 'Deploy Checklist.md',
                    type: 'file',
                    size: 16384,
                    modified: '2026-02-20T15:00:00Z',
                  },
                  {
                    id: 'sd-002-f02-f01',
                    name: 'Post-Mortems',
                    type: 'folder',
                    size: 98304,
                    modified: '2026-03-24T14:00:00Z',
                    children: [
                      {
                        id: 'sd-002-f02-f01-001',
                        name: '2026-02-14 API Outage.gdoc',
                        type: 'file',
                        size: 45056,
                        modified: '2026-02-16T10:00:00Z',
                      },
                      {
                        id: 'sd-002-f02-f01-002',
                        name: '2026-03-22 DB Failover.gdoc',
                        type: 'file',
                        size: 53248,
                        modified: '2026-03-24T14:00:00Z',
                      },
                    ],
                  },
                ],
              },
              {
                id: 'sd-002-f03',
                name: 'Meeting Notes',
                type: 'folder',
                size: 118784,
                modified: '2026-04-05T17:00:00Z',
                children: [
                  {
                    id: 'sd-002-f03-001',
                    name: 'Sprint Retro 2026-03-29.docx',
                    type: 'file',
                    size: 61440,
                    modified: '2026-03-29T17:00:00Z',
                  },
                  {
                    id: 'sd-002-f03-002',
                    name: 'Sprint Retro 2026-04-05.docx',
                    type: 'file',
                    size: 57344,
                    modified: '2026-04-05T17:00:00Z',
                  },
                ],
              },
            ],
          },
          {
            id: 'sd-003',
            name: 'Finance',
            type: 'shared-drive',
            size: 3221225472,
            modified: '2026-04-02T10:00:00Z',
            children: [
              {
                id: 'sd-003-f01',
                name: 'Invoices',
                type: 'folder',
                size: 564224,
                modified: '2026-03-31T08:05:00Z',
                children: [
                  {
                    id: 'sd-003-f01-f01',
                    name: '2026',
                    type: 'folder',
                    size: 564224,
                    modified: '2026-03-31T08:05:00Z',
                    children: [
                      {
                        id: 'sd-003-f01-f01-f01',
                        name: 'Q1',
                        type: 'folder',
                        size: 564224,
                        modified: '2026-03-31T08:05:00Z',
                        children: [
                          {
                            id: 'sd-003-f01-f01-f01-001',
                            name: 'Vendor_AWS_Jan.pdf',
                            type: 'file',
                            size: 156672,
                            modified: '2026-01-31T08:00:00Z',
                          },
                          {
                            id: 'sd-003-f01-f01-f01-002',
                            name: 'Vendor_AWS_Feb.pdf',
                            type: 'file',
                            size: 161792,
                            modified: '2026-02-28T08:00:00Z',
                          },
                          {
                            id: 'sd-003-f01-f01-f01-003',
                            name: 'Vendor_AWS_Mar.pdf',
                            type: 'file',
                            size: 143360,
                            modified: '2026-03-31T08:00:00Z',
                          },
                          {
                            id: 'sd-003-f01-f01-f01-004',
                            name: 'Vendor_Datadog_Q1.pdf',
                            type: 'file',
                            size: 102400,
                            modified: '2026-03-31T08:05:00Z',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 'sd-003-f02',
                name: 'Reports',
                type: 'folder',
                size: 12046336,
                modified: '2026-04-02T14:00:00Z',
                children: [
                  {
                    id: 'sd-003-f02-001',
                    name: 'Q1 2026 Financial Summary.xlsx',
                    type: 'file',
                    size: 512000,
                    modified: '2026-04-02T10:00:00Z',
                  },
                  {
                    id: 'sd-003-f02-f01',
                    name: 'Board Decks',
                    type: 'folder',
                    size: 11534336,
                    modified: '2026-04-02T14:00:00Z',
                    children: [
                      {
                        id: 'sd-003-f02-f01-001',
                        name: 'Board Deck Q4 2025.pptx',
                        type: 'file',
                        size: 5242880,
                        modified: '2026-01-10T09:00:00Z',
                      },
                      {
                        id: 'sd-003-f02-f01-002',
                        name: 'Board Deck Q1 2026.pptx',
                        type: 'file',
                        size: 6291456,
                        modified: '2026-04-02T14:00:00Z',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'users',
        name: 'Users',
        type: 'folder',
        size: 17716740096,
        modified: '2026-04-03T14:00:00Z',
        children: [
          {
            id: 'user-001',
            name: 'Dana Reeves',
            type: 'user',
            email: 'dana@finapp.com',
            size: 4831838208,
            lastBackup: '2026-04-04T22:30:00Z',
            children: [
              {
                id: 'user-001-gdrive',
                name: 'GDrive',
                type: 'folder',
                size: 178544640,
                modified: '2026-04-03T11:00:00Z',
                children: [
                  {
                    id: 'user-001-gd-f01',
                    name: 'Projects',
                    type: 'folder',
                    size: 18763776,
                    modified: '2026-04-03T11:00:00Z',
                    children: [
                      {
                        id: 'user-001-gd-f01-f01',
                        name: 'Platform Redesign',
                        type: 'folder',
                        size: 16035840,
                        modified: '2026-04-03T11:00:00Z',
                        children: [
                          {
                            id: 'user-001-gd-f01-f01-001',
                            name: 'Requirements.docx',
                            type: 'file',
                            size: 286720,
                            modified: '2026-03-25T14:00:00Z',
                          },
                          {
                            id: 'user-001-gd-f01-f01-002',
                            name: 'Wireframes.fig',
                            type: 'file',
                            size: 4194304,
                            modified: '2026-03-28T16:30:00Z',
                          },
                          {
                            id: 'user-001-gd-f01-f01-003',
                            name: 'Notes.gdoc',
                            type: 'file',
                            size: 20480,
                            modified: '2026-04-03T11:00:00Z',
                          },
                          {
                            id: 'user-001-gd-f01-f01-f01',
                            name: 'Mockups',
                            type: 'folder',
                            size: 11534336,
                            modified: '2026-03-30T15:00:00Z',
                            children: [
                              {
                                id: 'user-001-gd-f01-f01-f01-001',
                                name: 'Dashboard_v2.fig',
                                type: 'file',
                                size: 8388608,
                                modified: '2026-03-30T15:00:00Z',
                              },
                              {
                                id: 'user-001-gd-f01-f01-f01-002',
                                name: 'Settings_v1.fig',
                                type: 'file',
                                size: 3145728,
                                modified: '2026-03-29T11:00:00Z',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        id: 'user-001-gd-f01-f02',
                        name: 'Cloud Migration',
                        type: 'folder',
                        size: 2727936,
                        modified: '2026-02-15T09:00:00Z',
                        children: [
                          {
                            id: 'user-001-gd-f01-f02-001',
                            name: 'Migration Plan v2.gsheet',
                            type: 'file',
                            size: 61440,
                            modified: '2026-02-15T09:00:00Z',
                          },
                          {
                            id: 'user-001-gd-f01-f02-002',
                            name: 'Vendor Comparison.gsheet',
                            type: 'file',
                            size: 45056,
                            modified: '2026-02-10T14:20:00Z',
                          },
                          {
                            id: 'user-001-gd-f01-f02-f01',
                            name: 'Vendor Proposals',
                            type: 'folder',
                            size: 2621440,
                            modified: '2026-02-06T14:00:00Z',
                            children: [
                              {
                                id: 'user-001-gd-f01-f02-f01-001',
                                name: 'AWS_proposal.pdf',
                                type: 'file',
                                size: 1048576,
                                modified: '2026-02-05T10:00:00Z',
                              },
                              {
                                id: 'user-001-gd-f01-f02-f01-002',
                                name: 'GCP_proposal.pdf',
                                type: 'file',
                                size: 1572864,
                                modified: '2026-02-06T14:00:00Z',
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: 'user-001-gd-f02',
                    name: 'Personal',
                    type: 'folder',
                    size: 921600,
                    modified: '2026-02-01T12:00:00Z',
                    children: [
                      {
                        id: 'user-001-gd-f02-001',
                        name: 'Resume 2026.pdf',
                        type: 'file',
                        size: 307200,
                        modified: '2026-01-10T08:00:00Z',
                      },
                      {
                        id: 'user-001-gd-f02-f01',
                        name: 'Tax Documents',
                        type: 'folder',
                        size: 614400,
                        modified: '2026-02-01T12:00:00Z',
                        children: [
                          {
                            id: 'user-001-gd-f02-f01-001',
                            name: '2025 Summary.pdf',
                            type: 'file',
                            size: 409600,
                            modified: '2026-02-01T12:00:00Z',
                          },
                          {
                            id: 'user-001-gd-f02-f01-002',
                            name: 'W2 2025.pdf',
                            type: 'file',
                            size: 204800,
                            modified: '2026-01-28T09:00:00Z',
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: 'user-001-gd-003',
                    name: 'screenshot_2026-04-01.png',
                    type: 'file',
                    size: 1572864,
                    modified: '2026-04-01T15:22:00Z',
                  },
                  {
                    id: 'user-001-gd-004',
                    name: 'meeting-recording-2026-03-30.mp4',
                    type: 'file',
                    size: 157286400,
                    modified: '2026-03-30T17:00:00Z',
                  },
                ],
              },
              {
                id: 'user-001-gmail',
                name: 'Gmail',
                type: 'folder',
                size: 6682624,
                children: [
                  {
                    id: 'user-001-gmail-allmail',
                    name: 'All Mail',
                    type: 'mail-folder',
                    count: 8,
                    size: 6647808,
                    children: [
                      {
                        id: '19d0b1a781d99b12',
                        name: 'Re: Q2 Planning Meeting',
                        type: 'email',
                        from: 'Mira Okafor <mira@finapp.com>',
                        to: 'dana@finapp.com',
                        size: 24576,
                        date: '2026-04-04T16:45:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d0a8e3c2f44a01',
                        name: 'Invoice #4821 - Cloud Services',
                        type: 'email',
                        from: 'billing@cloudprovider.com',
                        to: 'dana@finapp.com',
                        size: 184320,
                        date: '2026-04-04T09:12:00Z',
                        hasAttachments: true,
                      },
                      {
                        id: '19d09f12ab8c7e55',
                        name: 'Weekly Engineering Digest',
                        type: 'email',
                        from: 'digest@finapp.com',
                        to: 'engineering@finapp.com',
                        size: 61440,
                        date: '2026-04-03T08:00:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d08a44de3b1c90',
                        name: 'Backup Status Report - Success',
                        type: 'email',
                        from: 'notifications@keepit.com',
                        to: 'dana@finapp.com',
                        size: 12288,
                        date: '2026-04-02T22:35:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d07bc901a2df44',
                        name: 'Re: API Integration Feedback',
                        type: 'email',
                        from: 'Kai Brennan <kai@finapp.com>',
                        to: 'dana@finapp.com',
                        size: 40960,
                        date: '2026-04-02T14:20:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d06a1178c3ee02',
                        name: 'Board Deck Review',
                        type: 'email',
                        from: 'Zara Petrov <zara@finapp.com>',
                        to: 'leadership@finapp.com',
                        size: 5242880,
                        date: '2026-04-01T11:00:00Z',
                        hasAttachments: true,
                      },
                      {
                        id: '19d05123aabb4410',
                        name: 'New Hire Onboarding - IT Setup',
                        type: 'email',
                        from: 'hr@finapp.com',
                        to: 'dana@finapp.com',
                        size: 32768,
                        date: '2026-03-31T09:30:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d04015cc7890ab',
                        name: 'Signed: MSA - Partner Corp',
                        type: 'email',
                        from: 'noreply@docusign.com',
                        to: 'dana@finapp.com',
                        size: 1048576,
                        date: '2026-03-30T15:00:00Z',
                        hasAttachments: true,
                      },
                    ],
                  },
                  {
                    id: 'user-001-gmail-spam',
                    name: 'Spam',
                    type: 'mail-folder',
                    count: 2,
                    size: 24576,
                    children: [
                      {
                        id: '19d0c112fa9900cc',
                        name: "You've won a free iPhone!",
                        type: 'email',
                        from: 'deals@totallylegit.biz',
                        to: 'dana@finapp.com',
                        size: 8192,
                        date: '2026-04-04T03:12:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d0b001ed7733aa',
                        name: 'Urgent: Verify your account',
                        type: 'email',
                        from: 'security@bankk-alerts.com',
                        to: 'dana@finapp.com',
                        size: 16384,
                        date: '2026-04-03T01:45:00Z',
                        hasAttachments: false,
                      },
                    ],
                  },
                  {
                    id: 'user-001-gmail-trash',
                    name: 'Trash',
                    type: 'mail-folder',
                    count: 1,
                    size: 10240,
                    children: [
                      {
                        id: '19d0a001bb5544dd',
                        name: 'Old meeting invite - Cancelled',
                        type: 'email',
                        from: 'calendar@finapp.com',
                        to: 'dana@finapp.com',
                        size: 10240,
                        date: '2026-03-28T12:00:00Z',
                        hasAttachments: false,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: 'user-002',
            name: 'Mira Okafor',
            type: 'user',
            email: 'mira@finapp.com',
            size: 2147483648,
            lastBackup: '2026-04-04T22:30:00Z',
            children: [
              {
                id: 'user-002-gdrive',
                name: 'GDrive',
                type: 'folder',
                size: 210239488,
                modified: '2026-04-01T10:00:00Z',
                children: [
                  {
                    id: 'user-002-gd-f01',
                    name: 'Product',
                    type: 'folder',
                    size: 199720960,
                    modified: '2026-04-01T10:00:00Z',
                    children: [
                      {
                        id: 'user-002-gd-f01-001',
                        name: 'Roadmap H1 2026.gsheet',
                        type: 'file',
                        size: 81920,
                        modified: '2026-04-01T10:00:00Z',
                      },
                      {
                        id: 'user-002-gd-f01-002',
                        name: 'PRD - Backup Browser.gdoc',
                        type: 'file',
                        size: 143360,
                        modified: '2026-03-20T15:30:00Z',
                      },
                      {
                        id: 'user-002-gd-f01-f01',
                        name: 'User Research',
                        type: 'folder',
                        size: 199495680,
                        modified: '2026-03-18T14:00:00Z',
                        children: [
                          {
                            id: 'user-002-gd-f01-f01-001',
                            name: 'Interview Notes.gdoc',
                            type: 'file',
                            size: 61440,
                            modified: '2026-03-15T11:00:00Z',
                          },
                          {
                            id: 'user-002-gd-f01-f01-002',
                            name: 'Survey Results.gsheet',
                            type: 'file',
                            size: 204800,
                            modified: '2026-03-18T14:00:00Z',
                          },
                          {
                            id: 'user-002-gd-f01-f01-f01',
                            name: 'Recordings',
                            type: 'folder',
                            size: 199229440,
                            modified: '2026-03-16T16:00:00Z',
                            children: [
                              {
                                id: 'user-002-gd-f01-f01-f01-001',
                                name: 'Interview_CustomerA.mp4',
                                type: 'file',
                                size: 104857600,
                                modified: '2026-03-14T15:00:00Z',
                              },
                              {
                                id: 'user-002-gd-f01-f01-f01-002',
                                name: 'Interview_CustomerB.mp4',
                                type: 'file',
                                size: 94371840,
                                modified: '2026-03-16T16:00:00Z',
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: 'user-002-gd-f02',
                    name: 'Design',
                    type: 'folder',
                    size: 10518528,
                    modified: '2026-03-23T10:05:00Z',
                    children: [
                      {
                        id: 'user-002-gd-f02-001',
                        name: 'Mockups_v3.fig',
                        type: 'file',
                        size: 8388608,
                        modified: '2026-03-22T16:00:00Z',
                      },
                      {
                        id: 'user-002-gd-f02-f01',
                        name: 'Exports',
                        type: 'folder',
                        size: 2129920,
                        modified: '2026-03-23T10:05:00Z',
                        children: [
                          {
                            id: 'user-002-gd-f02-f01-001',
                            name: 'Dashboard_final.png',
                            type: 'file',
                            size: 2097152,
                            modified: '2026-03-23T10:00:00Z',
                          },
                          {
                            id: 'user-002-gd-f02-f01-002',
                            name: 'Icons_sprite.svg',
                            type: 'file',
                            size: 32768,
                            modified: '2026-03-23T10:05:00Z',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 'user-002-gmail',
                name: 'Gmail',
                type: 'folder',
                size: 102400,
                children: [
                  {
                    id: 'user-002-gmail-allmail',
                    name: 'All Mail',
                    type: 'mail-folder',
                    count: 4,
                    size: 102400,
                    children: [
                      {
                        id: '19d0b2cc44aa1100',
                        name: 'Re: Q2 Planning Meeting',
                        type: 'email',
                        from: 'Dana Reeves <dana@finapp.com>',
                        to: 'mira@finapp.com',
                        size: 20480,
                        date: '2026-04-04T17:00:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d0a5ee33bb2211',
                        name: 'Design Review Tomorrow',
                        type: 'email',
                        from: 'Zara Petrov <zara@finapp.com>',
                        to: 'mira@finapp.com',
                        size: 16384,
                        date: '2026-04-03T18:30:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d09011ccdd5566',
                        name: 'Figma Comment: Backup Browser',
                        type: 'email',
                        from: 'notifications@figma.com',
                        to: 'mira@finapp.com',
                        size: 28672,
                        date: '2026-04-02T10:15:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d08122ddee7788',
                        name: 'Sprint Planning Notes',
                        type: 'email',
                        from: 'jira@finapp.atlassian.net',
                        to: 'mira@finapp.com',
                        size: 36864,
                        date: '2026-04-01T09:00:00Z',
                        hasAttachments: true,
                      },
                    ],
                  },
                  {
                    id: 'user-002-gmail-spam',
                    name: 'Spam',
                    type: 'mail-folder',
                    count: 0,
                    children: [],
                  },
                  {
                    id: 'user-002-gmail-trash',
                    name: 'Trash',
                    type: 'mail-folder',
                    count: 0,
                    children: [],
                  },
                ],
              },
            ],
          },
          {
            id: 'user-003',
            name: 'Kai Brennan',
            type: 'user',
            email: 'kai@finapp.com',
            size: 6442450944,
            lastBackup: '2026-04-04T22:30:00Z',
            children: [
              {
                id: 'user-003-gdrive',
                name: 'GDrive',
                type: 'folder',
                size: 17211392,
                modified: '2026-04-01T10:30:00Z',
                children: [
                  {
                    id: 'user-003-gd-f01',
                    name: 'Engineering',
                    type: 'folder',
                    size: 430080,
                    modified: '2026-04-01T09:00:00Z',
                    children: [
                      {
                        id: 'user-003-gd-f01-f01',
                        name: 'Infra',
                        type: 'folder',
                        size: 307200,
                        modified: '2026-04-01T09:00:00Z',
                        children: [
                          {
                            id: 'user-003-gd-f01-f01-001',
                            name: 'Terraform Modules.gdoc',
                            type: 'file',
                            size: 40960,
                            modified: '2026-03-15T10:00:00Z',
                          },
                          {
                            id: 'user-003-gd-f01-f01-002',
                            name: 'Cost Analysis Q1.gsheet',
                            type: 'file',
                            size: 122880,
                            modified: '2026-04-01T09:00:00Z',
                          },
                          {
                            id: 'user-003-gd-f01-f01-f01',
                            name: 'Diagrams',
                            type: 'folder',
                            size: 143360,
                            modified: '2026-03-20T14:00:00Z',
                            children: [
                              {
                                id: 'user-003-gd-f01-f01-f01-001',
                                name: 'Network Topology.drawio',
                                type: 'file',
                                size: 81920,
                                modified: '2026-03-20T14:00:00Z',
                              },
                              {
                                id: 'user-003-gd-f01-f01-f01-002',
                                name: 'CI Pipeline.drawio',
                                type: 'file',
                                size: 61440,
                                modified: '2026-03-18T11:00:00Z',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        id: 'user-003-gd-f01-001',
                        name: 'Performance Benchmarks.gsheet',
                        type: 'file',
                        size: 122880,
                        modified: '2026-03-30T16:00:00Z',
                      },
                    ],
                  },
                  {
                    id: 'user-003-gd-f02',
                    name: 'Training',
                    type: 'folder',
                    size: 16744448,
                    modified: '2026-03-10T09:00:00Z',
                    children: [
                      {
                        id: 'user-003-gd-f02-001',
                        name: 'GCP Certification Notes.gdoc',
                        type: 'file',
                        size: 81920,
                        modified: '2026-03-10T09:00:00Z',
                      },
                      {
                        id: 'user-003-gd-f02-002',
                        name: 'Kubernetes Workshop.pdf',
                        type: 'file',
                        size: 15728640,
                        modified: '2026-02-28T11:00:00Z',
                      },
                      {
                        id: 'user-003-gd-f02-f01',
                        name: 'Certificates',
                        type: 'folder',
                        size: 933888,
                        modified: '2026-01-20T14:00:00Z',
                        children: [
                          {
                            id: 'user-003-gd-f02-f01-001',
                            name: 'AWS_SA_Pro.pdf',
                            type: 'file',
                            size: 524288,
                            modified: '2025-11-15T10:00:00Z',
                          },
                          {
                            id: 'user-003-gd-f02-f01-002',
                            name: 'CKA_cert.pdf',
                            type: 'file',
                            size: 409600,
                            modified: '2026-01-20T14:00:00Z',
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: 'user-003-gd-f03',
                    name: '1:1 Notes',
                    type: 'folder',
                    size: 36864,
                    modified: '2026-04-01T10:30:00Z',
                    children: [
                      {
                        id: 'user-003-gd-f03-001',
                        name: 'Dana 2026-04-01.gdoc',
                        type: 'file',
                        size: 16384,
                        modified: '2026-04-01T10:30:00Z',
                      },
                      {
                        id: 'user-003-gd-f03-002',
                        name: 'Dana 2026-03-25.gdoc',
                        type: 'file',
                        size: 20480,
                        modified: '2026-03-25T10:30:00Z',
                      },
                    ],
                  },
                ],
              },
              {
                id: 'user-003-gmail',
                name: 'Gmail',
                type: 'folder',
                size: 122880,
                children: [
                  {
                    id: 'user-003-gmail-allmail',
                    name: 'All Mail',
                    type: 'mail-folder',
                    count: 5,
                    size: 114688,
                    children: [
                      {
                        id: '19d0b5aa11cc3344',
                        name: 'Re: API Integration Feedback',
                        type: 'email',
                        from: 'Dana Reeves <dana@finapp.com>',
                        to: 'kai@finapp.com',
                        size: 36864,
                        date: '2026-04-02T14:30:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d0a3bb22dd4455',
                        name: 'GitHub: PR #342 merged',
                        type: 'email',
                        from: 'notifications@github.com',
                        to: 'kai@finapp.com',
                        size: 20480,
                        date: '2026-04-01T16:45:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d09244cc556677',
                        name: 'PagerDuty: Incident Resolved',
                        type: 'email',
                        from: 'alerts@pagerduty.com',
                        to: 'kai@finapp.com',
                        size: 12288,
                        date: '2026-03-31T02:15:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d08355dd667788',
                        name: 'AWS Cost Alert: Threshold Exceeded',
                        type: 'email',
                        from: 'no-reply@aws.amazon.com',
                        to: 'kai@finapp.com',
                        size: 28672,
                        date: '2026-03-30T06:00:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d07466ee778899',
                        name: 'Terraform Cloud: Run completed',
                        type: 'email',
                        from: 'notifications@hashicorp.com',
                        to: 'kai@finapp.com',
                        size: 16384,
                        date: '2026-03-29T14:20:00Z',
                        hasAttachments: false,
                      },
                    ],
                  },
                  {
                    id: 'user-003-gmail-spam',
                    name: 'Spam',
                    type: 'mail-folder',
                    count: 0,
                    children: [],
                  },
                  {
                    id: 'user-003-gmail-trash',
                    name: 'Trash',
                    type: 'mail-folder',
                    count: 1,
                    size: 8192,
                    children: [
                      {
                        id: '19d06577ff889900',
                        name: 'Outdated calendar invite',
                        type: 'email',
                        from: 'calendar@finapp.com',
                        to: 'kai@finapp.com',
                        size: 8192,
                        date: '2026-03-20T09:00:00Z',
                        hasAttachments: false,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: 'user-004',
            name: 'Zara Petrov',
            type: 'user',
            email: 'zara@finapp.com',
            size: 1073741824,
            lastBackup: '2026-04-04T22:30:00Z',
            children: [
              {
                id: 'user-004-gdrive',
                name: 'GDrive',
                type: 'folder',
                size: 12509184,
                modified: '2026-04-03T14:00:00Z',
                children: [
                  {
                    id: 'user-004-gd-f01',
                    name: 'Leadership',
                    type: 'folder',
                    size: 12365824,
                    modified: '2026-04-03T14:00:00Z',
                    children: [
                      {
                        id: 'user-004-gd-f01-f01',
                        name: 'Board Materials',
                        type: 'folder',
                        size: 12304384,
                        modified: '2026-04-03T14:00:00Z',
                        children: [
                          {
                            id: 'user-004-gd-f01-f01-001',
                            name: 'Investor Update Q1.pptx',
                            type: 'file',
                            size: 6291456,
                            modified: '2026-04-03T14:00:00Z',
                          },
                          {
                            id: 'user-004-gd-f01-f01-002',
                            name: 'Cap Table.xlsx',
                            type: 'file',
                            size: 245760,
                            modified: '2026-03-15T10:00:00Z',
                          },
                          {
                            id: 'user-004-gd-f01-f01-f01',
                            name: 'Previous Quarters',
                            type: 'folder',
                            size: 5767168,
                            modified: '2026-01-08T09:00:00Z',
                            children: [
                              {
                                id: 'user-004-gd-f01-f01-f01-001',
                                name: 'Investor Update Q4 2025.pptx',
                                type: 'file',
                                size: 5767168,
                                modified: '2026-01-08T09:00:00Z',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        id: 'user-004-gd-f01-001',
                        name: 'OKRs H1 2026.gsheet',
                        type: 'file',
                        size: 61440,
                        modified: '2026-01-05T11:00:00Z',
                      },
                    ],
                  },
                  {
                    id: 'user-004-gd-f02',
                    name: 'Hiring',
                    type: 'folder',
                    size: 143360,
                    modified: '2026-03-12T10:00:00Z',
                    children: [
                      {
                        id: 'user-004-gd-f02-f01',
                        name: 'Open Roles',
                        type: 'folder',
                        size: 61440,
                        modified: '2026-03-12T10:00:00Z',
                        children: [
                          {
                            id: 'user-004-gd-f02-f01-001',
                            name: 'Sr Backend Engineer JD.gdoc',
                            type: 'file',
                            size: 32768,
                            modified: '2026-03-10T09:00:00Z',
                          },
                          {
                            id: 'user-004-gd-f02-f01-002',
                            name: 'Product Designer JD.gdoc',
                            type: 'file',
                            size: 28672,
                            modified: '2026-03-12T10:00:00Z',
                          },
                        ],
                      },
                      {
                        id: 'user-004-gd-f02-001',
                        name: 'Headcount Plan 2026.gsheet',
                        type: 'file',
                        size: 81920,
                        modified: '2026-01-15T14:00:00Z',
                      },
                    ],
                  },
                ],
              },
              {
                id: 'user-004-gmail',
                name: 'Gmail',
                type: 'folder',
                size: 77824,
                children: [
                  {
                    id: 'user-004-gmail-allmail',
                    name: 'All Mail',
                    type: 'mail-folder',
                    count: 3,
                    size: 77824,
                    children: [
                      {
                        id: '19d0b6bb22dd5566',
                        name: 'Board Meeting Follow-up',
                        type: 'email',
                        from: 'investor@sequoia.com',
                        to: 'zara@finapp.com',
                        size: 40960,
                        date: '2026-04-04T18:00:00Z',
                        hasAttachments: true,
                      },
                      {
                        id: '19d0a7cc33ee6677',
                        name: 'Re: Series B Timeline',
                        type: 'email',
                        from: 'counsel@legal.com',
                        to: 'zara@finapp.com',
                        size: 20480,
                        date: '2026-04-03T11:30:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d098dd44ff7788',
                        name: 'Offer Accepted - Sr Backend Eng',
                        type: 'email',
                        from: 'recruiting@greenhouse.io',
                        to: 'zara@finapp.com',
                        size: 16384,
                        date: '2026-04-01T15:00:00Z',
                        hasAttachments: false,
                      },
                    ],
                  },
                  {
                    id: 'user-004-gmail-spam',
                    name: 'Spam',
                    type: 'mail-folder',
                    count: 0,
                    children: [],
                  },
                  {
                    id: 'user-004-gmail-trash',
                    name: 'Trash',
                    type: 'mail-folder',
                    count: 0,
                    children: [],
                  },
                ],
              },
            ],
          },
          {
            id: 'user-005',
            name: 'Remy Tanaka',
            type: 'user',
            email: 'remy@finapp.com',
            size: 3221225472,
            lastBackup: '2026-04-04T22:30:00Z',
            children: [
              {
                id: 'user-005-gdrive',
                name: 'GDrive',
                type: 'folder',
                size: 11345920,
                modified: '2026-04-03T10:00:00Z',
                children: [
                  {
                    id: 'user-005-gd-f01',
                    name: 'Sales',
                    type: 'folder',
                    size: 11276288,
                    modified: '2026-04-03T10:00:00Z',
                    children: [
                      {
                        id: 'user-005-gd-f01-f01',
                        name: 'Proposals',
                        type: 'folder',
                        size: 11010048,
                        modified: '2026-04-02T16:00:00Z',
                        children: [
                          {
                            id: 'user-005-gd-f01-f01-001',
                            name: 'Acme Corp - Enterprise.pptx',
                            type: 'file',
                            size: 4194304,
                            modified: '2026-04-02T16:00:00Z',
                          },
                          {
                            id: 'user-005-gd-f01-f01-002',
                            name: 'TechStart - SMB.pptx',
                            type: 'file',
                            size: 3145728,
                            modified: '2026-03-28T11:00:00Z',
                          },
                          {
                            id: 'user-005-gd-f01-f01-f01',
                            name: 'Templates',
                            type: 'folder',
                            size: 3670016,
                            modified: '2026-02-15T09:05:00Z',
                            children: [
                              {
                                id: 'user-005-gd-f01-f01-f01-001',
                                name: 'Enterprise_template_v4.pptx',
                                type: 'file',
                                size: 2097152,
                                modified: '2026-02-15T09:00:00Z',
                              },
                              {
                                id: 'user-005-gd-f01-f01-f01-002',
                                name: 'SMB_template_v3.pptx',
                                type: 'file',
                                size: 1572864,
                                modified: '2026-02-15T09:05:00Z',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        id: 'user-005-gd-f01-f02',
                        name: 'Pipeline Reports',
                        type: 'folder',
                        size: 266240,
                        modified: '2026-04-03T10:00:00Z',
                        children: [
                          {
                            id: 'user-005-gd-f01-f02-001',
                            name: 'March Pipeline.gsheet',
                            type: 'file',
                            size: 102400,
                            modified: '2026-03-31T18:00:00Z',
                          },
                          {
                            id: 'user-005-gd-f01-f02-002',
                            name: 'Q1 Win-Loss Analysis.gsheet',
                            type: 'file',
                            size: 163840,
                            modified: '2026-04-03T10:00:00Z',
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: 'user-005-gd-f02',
                    name: 'Customer Success',
                    type: 'folder',
                    size: 69632,
                    modified: '2026-02-01T10:05:00Z',
                    children: [
                      {
                        id: 'user-005-gd-f02-f01',
                        name: 'Onboarding Docs',
                        type: 'folder',
                        size: 69632,
                        modified: '2026-02-01T10:05:00Z',
                        children: [
                          {
                            id: 'user-005-gd-f02-f01-001',
                            name: 'Welcome Guide.gdoc',
                            type: 'file',
                            size: 40960,
                            modified: '2026-02-01T10:00:00Z',
                          },
                          {
                            id: 'user-005-gd-f02-f01-002',
                            name: 'Integration Checklist.gsheet',
                            type: 'file',
                            size: 28672,
                            modified: '2026-02-01T10:05:00Z',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 'user-005-gmail',
                name: 'Gmail',
                type: 'folder',
                size: 135168,
                children: [
                  {
                    id: 'user-005-gmail-allmail',
                    name: 'All Mail',
                    type: 'mail-folder',
                    count: 4,
                    size: 135168,
                    children: [
                      {
                        id: '19d0b8dd55ee8899',
                        name: 'Re: Enterprise License Agreement',
                        type: 'email',
                        from: 'procurement@acmecorp.com',
                        to: 'remy@finapp.com',
                        size: 61440,
                        date: '2026-04-04T15:30:00Z',
                        hasAttachments: true,
                      },
                      {
                        id: '19d0a9ee66ff9900',
                        name: 'Salesforce: Deal Stage Updated',
                        type: 'email',
                        from: 'notifications@salesforce.com',
                        to: 'remy@finapp.com',
                        size: 16384,
                        date: '2026-04-03T14:00:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d09aff77001122',
                        name: 'Customer QBR Recap - TechStart',
                        type: 'email',
                        from: 'Remy Tanaka <remy@finapp.com>',
                        to: 'success@finapp.com',
                        size: 45056,
                        date: '2026-04-02T17:00:00Z',
                        hasAttachments: false,
                      },
                      {
                        id: '19d08b0088112233',
                        name: 'Intro: FinApp <> MegaCorp',
                        type: 'email',
                        from: 'referral@partner.com',
                        to: 'remy@finapp.com',
                        size: 12288,
                        date: '2026-04-01T10:00:00Z',
                        hasAttachments: false,
                      },
                    ],
                  },
                  {
                    id: 'user-005-gmail-spam',
                    name: 'Spam',
                    type: 'mail-folder',
                    count: 0,
                    children: [],
                  },
                  {
                    id: 'user-005-gmail-trash',
                    name: 'Trash',
                    type: 'mail-folder',
                    count: 0,
                    children: [],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
